import React from 'react'
import withStyles from 'react-jss'
import classNames from 'classnames'

import appLoaderStyle from './app-loader-style'

const AppLoader = ({ classes }) => <span className={classNames(classes.appLoader, 'fal', 'fa-spinner', 'fa-spin')} />

export default withStyles(appLoaderStyle)(AppLoader)
